import { useSidebar } from "./index";
import SidebarActionButton from "./SidebarActionButton";

const SidebarFilterToggle = () => {
	const { toggleFilterOpen, isFilterOpen, hasFilterApplied } = useSidebar();

	return (
		<SidebarActionButton
			forceHover={hasFilterApplied && !isFilterOpen}
			isActive={isFilterOpen}
			onClick={toggleFilterOpen}
			dataAttr={{
				"data-opened": isFilterOpen,
				"data-tooltip-id": "tooltip_small_top",
				"data-tooltip-offset": 10,
				"data-tooltip-position-strategy": "fixed",
				"data-tooltip-content": "Filtri",
			}}
			iconClass="filters"
			hasPin={hasFilterApplied && !isFilterOpen}
		/>
	);
};

SidebarFilterToggle.displayName = "SidebarFilterToggle";

export default SidebarFilterToggle;
